import { render, staticRenderFns } from "./RefrainPositionModal.vue?vue&type=template&id=56c6b960&scoped=true&"
import script from "./RefrainPositionModal.vue?vue&type=script&lang=js&"
export * from "./RefrainPositionModal.vue?vue&type=script&lang=js&"
import style0 from "./RefrainPositionModal.vue?vue&type=style&index=0&id=56c6b960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c6b960",
  null
  
)

export default component.exports